var styles = {"textArea":"styles_text-area__CpUdE","inputSection":"styles_input-section__GRi6V","rawTextArea":"styles_raw-text-area__UTuKM"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
